import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Rating from '@mui/material/Rating';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAltOutlined';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';
import { getLngsltd } from '../../utils/langData.utils';


const lngsltd=getLngsltd();
// const languagecultureSelected = JSON.parse(localStorage.getItem('cultureSelected'));
    
// console.log(languagecultureSelected);


// Custom styles for the Rating component
const StyledRating = styled(Rating)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'row', // Horizontal layout for the rating
  width: '100%',
  '& .MuiRating-icon': {
    fontSize: '2.5rem', // Base size for icons
    margin: theme.spacing(0.5),
    [theme.breakpoints.up('md')]: {
      fontSize: '2.5rem', // Larger size for larger screens
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.8rem', // Smaller size for smaller screens
    },
    [theme.breakpoints.down(400)]: {
      fontSize: '1.4rem', // Very small size for very small screens
    },
    transition: 'all 0.3s ease', // Smooth transition for visual changes
  },
}));


// Define custom icons and labels
const customIcons = {
  1: {
    icon: <SentimentVeryDissatisfiedIcon fontSize="inherit" />,
    label: 'Very Dissatisfied',
    text:lngsltd?.['Bad'] || 'Bad',
    color: '#f44336', // Red color
  },
  2: {
    icon: <SentimentDissatisfiedIcon fontSize="inherit" />,
    label: 'Dissatisfied',    
    text:lngsltd?.['Poor'] || 'Poor',
    color: '#ff9800', // Orange color
  },
  3: {
    icon: <SentimentSatisfiedIcon fontSize="inherit" />,
    label: 'Neutral',
    text:lngsltd?.['Ok'] || 'Ok',
    color: '#ffeb3b', // Yellow color
  },
  4: {
    icon: <SentimentSatisfiedAltIcon fontSize="inherit" />,
    label: 'Satisfied',
    text:lngsltd?.['Good'] || 'Good',
    color: '#8bc34a', // Light green color
  },
  5: {
    icon: <SentimentVerySatisfiedIcon fontSize="inherit" />,
    label: 'Very Satisfied',
    text:lngsltd?.['Excellent'] || 'Excellent',    
    color: '#4caf50', // Dark green color
  },
};

// IconContainer component to display the icon and label
function IconContainer(props) {
  const { value, selectedValue, ...other } = props;

  return (
    <Tooltip title={customIcons[value].label} arrow>
      <span
        {...other}
        style={{
          display: 'flex',
          flexDirection: 'column', // Vertical alignment of icon and text
          alignItems: 'center',
          margin: '0 10px', // Space between each rating section
          position: 'relative', // For positioning the border or highlight
        }}
      >
        {/* Apply a border or highlight if the icon is selected */}
        {React.cloneElement(customIcons[value].icon, {
          sx: {
            color: customIcons[value].color, // Retain original color
            border: value === selectedValue ? `2px solid ${customIcons[value].color}` : 'none', // Highlight selected emoji
            borderRadius: '20%', // Rounded border
            padding: '4px', // Padding to make the border visible
          },
        })}
        <Typography
          variant="body2"
          sx={{
            mt: 0.5,
            color: customIcons[value].color, // Text color matches emoji color
          }}
        >
          {customIcons[value].text}
        </Typography>
      </span>
    </Tooltip>
  );
}

IconContainer.propTypes = {
  value: PropTypes.number.isRequired,
  selectedValue: PropTypes.number.isRequired, // Pass selected value to determine which emoji is selected
};

export default function CustomRating({ rating, setRating}) {
  return (
    <StyledRating
      name="highlight-selected-only"
      value={rating}      
      onChange={(event, newValue) => setRating(newValue)}
      IconContainerComponent={(props) => (
        <IconContainer {...props} selectedValue={rating} /> // Pass the selected value to IconContainer
      )}
      getLabelText={(value) => customIcons[value].label}
      highlightSelectedOnly      
    />
  );
}
